// Central API endpoint configuration for the frontend

const resolveApiBase = () => {
  const envUrl = (process.env.REACT_APP_API_URL || '').trim();
  if (envUrl) return envUrl;

  // During local development we still target the dev backend port.
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:4000/api';
  }

  // When no env override is provided (e.g. production), reuse the current
  // origin so we talk to the same host that served the frontend.
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/api`;
  }

  // Generic fallback for server-side rendering/tests.
  return 'http://localhost:4000/api';
};

// Base like: http://localhost:4000/api (no trailing slash)
export const API_BASE = resolveApiBase().replace(/\/$/, '');

// Build a URL by appending a path to API_BASE
export const apiUrl = (path = '') => {
  const p = typeof path === 'string' ? path : '';
  return `${API_BASE}${p.startsWith('/') ? p : `/${p}`}`;
};

// Origin portion of the API base, e.g., http://localhost:4000
export const API_ORIGIN = (() => {
  try {
    return new URL(API_BASE).origin;
  } catch {
    return '';
  }
})();
